var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.416 18.334h4.167M7.166 1.667h6.667m-3.333 2.5v-2.5M3.833 10h13.333m-2.5 5.834 1.25 2.5m-9.583-2.5-1.25 2.5m2.5-5.417h.008m5.825 0h.009m-5.592 2.917h5.333c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 0 0 1.093-1.092c.272-.535.272-1.235.272-2.635V8.167c0-1.4 0-2.1-.272-2.635A2.5 2.5 0 0 0 15.8 4.439c-.534-.272-1.235-.272-2.635-.272H7.833c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 0 0-1.093 1.093c-.272.535-.272 1.235-.272 2.635v3.667c0 1.4 0 2.1.272 2.635a2.5 2.5 0 0 0 1.093 1.092c.535.273 1.235.273 2.635.273zM8 12.917a.417.417 0 1 1-.834 0 .417.417 0 0 1 .834 0zm5.833 0a.417.417 0 1 1-.833 0 .417.417 0 0 1 .833 0z",
    stroke: "#667085",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.3433d2f5b5eb6d26adee4553f5399dc8.svg";
export { ForwardRef as ReactComponent };